// extracted by mini-css-extract-plugin
export default {"approval_box":"ApprovalLine_approval_box__lMag+","approval_team":"ApprovalLine_approval_team__y1ISV","approval_name":"ApprovalLine_approval_name__2zgZ2"};